import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import Logo from './Logo';
import LanguageToggle from './LanguageToggle';
import ThemeToggle from './ThemeToggle';

// Dashboard kabuğu dışındaki giriş-yapmış sayfalar için sade üst bar (checkout vb.)
export default function AppHeader() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="nav scrolled" style={{ position: 'static' }}>
      <div className="container">
        <Logo />
        <div className="nav-links">
          <ThemeToggle />
          <LanguageToggle />
          {user && (
            <button
              className="link"
              style={{ background: 'none', border: 0, cursor: 'pointer', font: 'inherit' }}
              onClick={() => { logout(); navigate('/'); }}
            >
              {t('nav.logout')}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
